import { useEffect, useState } from 'react';
import { path, isEmpty } from 'ramda';
import OrganizationService from '../services/OrganizationService';
import useObservable from './UseObservable';
import { requestObject } from '../lib/utils';


function useOrganization() {
  const orgService = OrganizationService.getInstance();
  const [organization, setOrganization] = useObservable(
    orgService.getOrganization(),
  );
  const [configuration] = useObservable(orgService.getConfiguration());
  const [loadingDataOrganization, setLoadingDataOrganization] = useState(false);
  // const { users } = organization || {};

  useEffect(() => {
    const authToken = localStorage.getItem('auth_token');

    if (authToken) {
      const currentOrgValue = orgService.getOrganization().getValue();
      if (!currentOrgValue || Object.keys(currentOrgValue).length === 0) {
        const promisedOrgFetch: any = orgService.fetchOrganization();
        if (promisedOrgFetch) {
          setLoadingDataOrganization(true);
          promisedOrgFetch.finally(() => {
            setLoadingDataOrganization(false);
          });
        }
      }
      const currentConfigValue = orgService.getConfiguration().getValue();
      if (!currentConfigValue || Object.keys(currentConfigValue).length === 0) {
        orgService.fetchConfig();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /*
  useEffect(() => {
    if (users && users.length > 0) {
      const email = localStorage.getItem('user_email');
      const user = users.find((u: any) => u.email === email);

      if (user) {
        localStorage.setItem('user_name', user.name);
        localStorage.setItem('user_lastname', user.lastname);
        localStorage.setItem('user_id', user.id);
      }
    }
  }, [users]);
  */

  /* eslint-disable-next-line */
  const fetchAdmin = async (adminId: number) =>
    orgService.getAdminDetail(adminId);

  const addAdmins = async (admins: any[]) => {
    return orgService.addAdmins(admins);
  };

  const editAdmins = async (admins: any, id: any) => {
    return orgService.editAdmins(admins, id);
  };

  const updateAdmins = async ({data, centerId, directorId}: any ) => {
    return orgService.updateAdmins(data, centerId, directorId);
  };

  const deleteAdmin = (id: any) => {
    return orgService.deleteAdmin(id)
    .then(( response: any) => {
      return response;
    });
  };

  const orgToken = path(
    ['kinedu_classrooms_token', 'access_token'],
    organization,
  );

  const addTeachersToOrg = (centerId: number, teacher: any) => {
    if (teacher) {
      try {
        const centerIndex = organization.centers.findIndex(
          (center: any) => center.id === centerId,
        );
        if (centerIndex !== -1) {
          const teacherCreatedSuccessful = organization.centers[
            centerIndex
          ].users.filter(({ errors }: any) => !errors || (errors && isEmpty(errors)));
          const allUsers = [...teacherCreatedSuccessful, ...teacher];
          const updatedOrganization = organization;

          updatedOrganization.centers[centerIndex].users = allUsers;
          setOrganization(updatedOrganization);
        }
      } catch (error) {

      }
    }
  };

  const updateTeacherInOrg = (
    action: string,
    centerId: number,
    teacherData: any,
  ) => {
    const teacherId = action === 'update' ? teacherData?.user?.id : teacherData;
    const centerIndex = organization.centers.findIndex(
      (center: any) => center?.id === centerId,
    );
    if (centerIndex !== -1) {
      const teacherIndex = organization.centers[centerIndex].users.findIndex(
        (t: any) => t.id === teacherId,
      );

      if (teacherIndex !== -1) {
        const centerUsers = path(['centers', centerIndex, 'users'], organization);
        const updatedOrganization = organization;

        if (action === 'update') {
          centerUsers[teacherIndex] = teacherData.user;
        } else {
          centerUsers.splice(teacherIndex, 1);
        }

        updatedOrganization.centers[centerIndex].users = centerUsers;
        setOrganization(updatedOrganization);
      }
    }
  };

  /* eslint-disable-next-line */
  const fetchOwner = async () => orgService.getOwnerDetail();

  const updateOwner = async (owner: any) => {
    return orgService.updateOwner(requestObject('user', owner));
  };

  const setOrganizationImage = async (image: any) => {
    const setImage = await orgService.addOrgImage(image);

    return setImage;
  };

  const updateConfig = (data: any, token: any = null) => orgService.updateConfig(data, token);

  return {
    organization,
    updateOwner,
    setOrganizationImage,
    addAdmins,
    editAdmins,
    updateAdmins,
    deleteAdmin,
    orgToken,
    addTeachersToOrg,
    updateTeacherInOrg,
    loadingDataOrganization,
    fetchAdmin,
    fetchOwner,
    updateConfig,
    configuration,
  };
}

export default useOrganization;
